import api from '../api'
import { Budget } from './budgetModel'

export const getBudgetYears = async (): Promise<number[]> => {
  const response = await api.get<number[]>('/budgets/years?includeNext=true&includeMissing=true')
  return response.data
}

export type YearlyBudgetResponse = {
  budgets: Budget[]
}

export const getBudget = async (year: number) => {
  const response = await api.get<YearlyBudgetResponse>(`/budgets/${year}`)
  return response.data.budgets
}

export const updateBudget = async (budgets: Budget[]) => {
  await api.post('/setup/budgets', budgets)
}

export type GetBudgetsResponse = {
  budgets: Budget[]
  years: number[]
  defaultYear: number
}

export const getBudgets = async (): Promise<GetBudgetsResponse> => {
  const response = await api.get<GetBudgetsResponse>('/budgets')
  return response.data
}

export const updateProjectItemPricing = async (year: number) => {
  await api.post(`/workareas/updateProjectsItemsPricingForBudgetYear/false/${year}`)
}
